import { useEffect } from 'react';

const BASE_TITLE = 'DynDev | Project Portal';

export function useDocumentTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} | DynDev` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
}
